import { ForecastMetricId } from './metrics';
import { SectionDescriptor, RowDescriptor } from './types';

export const FORECAST_COLUMNS = ['Value'] as const;

type Columns = typeof FORECAST_COLUMNS;
type ForecastRow = RowDescriptor<ForecastMetricId, Columns>;

const row = (id: string, label: string, metric: ForecastMetricId, isNegative?: boolean): ForecastRow => ({
    id,
    label,
    cells: [{ metric, isNegative }],
});

export const forecastLayout = (): SectionDescriptor<ForecastMetricId, Columns>[] => [
    {
        id: 'forecast-section-1',
        columns: FORECAST_COLUMNS,
        rows: [
            row('net-sale-proceeds', 'Net sale proceeds', 'netSaleProceeds'),
            row('permanent-loan-payoff', 'Permanent loan payoff', 'permanentLoanPayoff', true),
            row('equity-proceeds', 'Equity proceeds from sale', 'equityProceedsFromSale'),
        ],
    },
    {
        id: 'forecast-section-2',
        columns: FORECAST_COLUMNS,
        rows: [
            row('cash-on-cash-return', 'Cash-on-cash return', 'cashOnCashReturn'),
            row('debt-service-coverage-ratio', 'Debt service coverage ratio', 'debtServiceCoverageRatio'),
        ],
    },
    {
        id: 'forecast-section-3',
        columns: FORECAST_COLUMNS,
        rows: [
            row('operating-expense-ratio', 'Operating expense ratio', 'operatingExpenseRatio'),
            row('breakeven-occupancy', 'Breakeven occupancy', 'breakevenOccupancy'),
        ],
    },
];
